import type { DashboardReport } from "@/pages/dashboard/types";
import ReportCard from "@/pages/dashboard/components/report-card";

interface ReportsRowProps {
  reports: DashboardReport[];
}

const ReportsRow = ({ reports }: ReportsRowProps) => {
  return (
    <div className="flex flex-wrap gap-4 items-start w-full">
      {reports.map((report) => (
        <div key={report.title} className="flex-1 min-w-[320px] flex">
          <ReportCard report={report} />
        </div>
      ))}
    </div>
  );
};

export default ReportsRow;
